import React from "react";
import { Icon } from "@chakra-ui/react";

export const CesIcon = ({ ...props }) => {
  return (
    <Icon as="svg" viewBox="0 0 414 335" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.27538 112.601C8.3335 185.893 2.21726 213.381 5.27538 286.673C54.7379 312.323 76.7289 323.302 95.112 330.655C118.941 310.502 225.202 250.044 225.202 250.044C225.202 250.044 206.785 79.8205 206.785 59.4788C140.245 80.8513 71.8496 91.2283 5.27538 112.601Z"
        fill="white"
      />
      <path
        d="M302.17 171.375C302.17 171.375 316.894 186.477 359.003 172.732L352.234 128.957C352.234 128.957 316.155 154.092 308.544 136.877L302.17 171.375Z"
        fill="#D8E3FF"
      />
      <path
        d="M413.155 187.937C413.155 187.937 413.069 245.612 364.414 248.447C362.421 248.57 360.454 247.959 358.882 246.729L327.596 221.748C327.596 221.748 375.324 205.478 377.42 183.556L413.155 187.937Z"
        fill="#D8E3FF"
      />
      <path
        d="M301.276 141.189L296.036 172.732C296.036 172.732 308.612 194.07 351.409 180.137"
        stroke="#1A1A1A"
        strokeWidth="6.87218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M318.577 229.874L351.563 257.363C351.563 257.363 391.078 255.439 402.864 239.049"
        stroke="#1A1A1A"
        strokeWidth="6.87218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M92.4488 184.604L1.47827 143.079V60.9389L92.4488 102.464V184.604Z" fill="#6C2617" />
      <path
        d="M93.5649 186.597L93.3931 331.136"
        stroke="black"
        strokeWidth="6.87218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M67.5707 319.642L4.36378 287.291L3.43604 163.918" fill="white" />
      <path
        d="M67.5707 319.642L4.36378 287.291L3.43604 163.918"
        stroke="#1A1A1A"
        strokeWidth="6.87218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M213.45 113.064L92.4485 184.604V102.464L213.45 41.5077V113.064Z" fill="#D96D46" />
      <path
        d="M132.306 201.372L133.715 168.299"
        stroke="black"
        strokeWidth="6.87218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M93.5654 331.462L214.567 252.844"
        stroke="black"
        strokeWidth="6.87218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M213.449 36.2164L92.4473 97.1555L1.47681 55.6475L126.894 0L213.449 36.2164Z"
        fill="#A24A2F"
      />
      <path
        d="M164.004 272.035C164.004 272.035 68.6178 302.96 92.4471 185.48L164.004 272.035Z"
        fill="white"
        stroke="#1A1A1A"
        strokeWidth="6.87218"
        strokeLinejoin="round"
      />
      <path
        d="M92.4485 185.48C92.4485 185.48 129.266 304.729 213.468 307.375L320.33 207.557C320.33 207.557 209.482 169.227 213.124 117.084"
        fill="white"
      />
      <path
        d="M92.4485 185.48C92.4485 185.48 129.266 304.729 213.468 307.375L320.33 207.557C320.33 207.557 209.482 169.227 213.124 117.084"
        stroke="#1A1A1A"
        strokeWidth="6.87218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M346.598 237.331C346.598 237.331 356.614 238.001 363.675 234.015C365.599 232.955 367.821 232.556 369.994 232.883C372.168 233.209 374.173 234.24 375.702 235.819C378.674 238.757 383.261 240.801 390.357 239.581C382.929 244.857 374.19 247.984 365.101 248.618C362.796 248.701 360.533 247.97 358.71 246.556L346.598 237.331Z"
        fill="#355C8C"
      />
      <path
        d="M192.37 249.529L190.102 246.626L191.03 240.131C193.366 224.669 193.916 217.024 189.861 211.698C187.113 208.141 182.835 206.2 177.612 210.237C174.94 212.466 173.119 215.55 172.458 218.965L168.352 216.8C169.341 212.328 171.879 208.349 175.516 205.564C183.058 199.706 190.257 202.42 194.139 207.437C199.139 213.897 198.503 222.762 196.648 235.596L195.84 240.355L195.926 240.458L211.663 228.26L214.704 232.194L192.37 249.529Z"
        fill="#355C8C"
        stroke="#355C8C"
        strokeWidth="6.87218"
        strokeMiterlimit="10"
      />
      <path
        d="M218.81 221.594C222.169 220.786 225.266 219.137 227.813 216.8C233.379 211.457 231.695 206.269 229.084 203.657C224.737 199.225 218.776 201.183 214.687 205.203L212.281 207.523L209.155 204.276L211.577 201.956C214.721 198.933 217.143 193.486 213.501 189.707C211.044 187.147 207.248 186.442 203.193 190.274C200.966 192.545 199.449 195.417 198.829 198.537L194.757 196.476C195.682 192.468 197.76 188.818 200.736 185.978C207.041 179.931 213.484 180.927 217.212 184.81C220.373 188.109 221.112 192.799 218.535 198.005L218.638 198.091C220.889 196.479 223.643 195.73 226.399 195.979C229.154 196.228 231.73 197.46 233.654 199.448C238.567 204.602 238.808 212.866 231.231 220.236C228.352 223.074 224.761 225.086 220.837 226.06L218.81 221.594Z"
        fill="#355C8C"
        stroke="#355C8C"
        strokeWidth="6.87218"
        strokeMiterlimit="10"
      />
      <path
        d="M177.045 178.333C170.757 179.223 164.722 181.415 159.327 184.765C153.932 188.117 149.294 192.555 145.708 197.798C139.58 207.15 137.285 218.499 139.3 229.496C141.121 239.444 150.089 250.474 159.47 256.384C168.505 262.053 179.073 264.79 189.725 264.218C201.15 263.703 210.083 263.29 221.096 259.734C235.339 255.164 250.475 243.206 257.673 232.005C263.841 222.401 263.016 211.268 259.288 201.75C255.766 193.072 250.346 185.293 243.425 178.984C236.503 172.675 228.259 167.997 219.292 165.293C202.112 160.019 177.406 161.135 159.47 171.22"
        stroke="#D96D46"
        strokeWidth="8.59023"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M140.623 132.238C141.467 131.173 142.092 129.953 142.463 128.645C142.833 127.338 142.942 125.97 142.782 124.622C142.623 123.273 142.198 121.969 141.532 120.784C140.867 119.6 139.974 118.559 138.905 117.72C134.627 114.645 127.875 115.659 125.538 119.782C123.202 123.905 125.332 130.451 131.431 133.097"
        stroke="#1A1A1A"
        strokeWidth="6.87218"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M192.611 100.78C193.453 99.7164 194.075 98.4967 194.444 97.1913C194.813 95.886 194.922 94.5206 194.762 93.1735C194.602 91.8264 194.178 90.5241 193.514 89.3413C192.85 88.1582 191.96 87.1179 190.893 86.28C186.615 83.2047 179.863 84.2184 177.526 88.3417C175.19 92.465 177.32 99.0108 183.419 101.657"
        stroke="#1A1A1A"
        strokeWidth="6.87218"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M27.6604 160.62V298.957"
        stroke="#1A1A1A"
        strokeWidth="6.87218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.9634 312.1V235.63"
        stroke="#1A1A1A"
        strokeWidth="6.87218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.9634 225.889V206.217"
        stroke="#1A1A1A"
        strokeWidth="6.87218"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};
